import React, { useLayoutEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import { Page } from '../page'
import { Footer } from '../footer'

export interface TopBodyLayoutProps {
  top: React.ReactNode
  bodyScrollable?: boolean
}
const Top = styled.div`
  box-shadow: ${props => props.theme.shadows.outline};
`

const scrollableStyles = css<{ topHeight: number }>`
  max-height: calc(100% - ${props => props.topHeight}px);
  overflow: hidden auto;
`
const fixedStyles = css<{ topHeight: number }>`
  height: calc(100% - ${props => props.topHeight}px);
`

const Body = styled.div<{ topHeight: number, scrollable: boolean }>`
  width: 100%;
  height: calc(100vh - ${props => props.topHeight}px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  & > *:last-child {
    flex: none;
  }
  ${props => props.scrollable ? scrollableStyles : fixedStyles}
`
export const TopBodyLayout: React.FC<TopBodyLayoutProps> = ({
  children,
  top,
  bodyScrollable = true
}) => {
  const topRef = useRef<HTMLDivElement>(null)
  const [topHeight, setTopHeight] = useState(0)
  useLayoutEffect(() => setTopHeight(topRef.current?.scrollHeight ?? 0))
  return (
    <Page>
      <Top ref={topRef}>
        {top}
      </Top>
      <Body topHeight={topHeight} scrollable={bodyScrollable}>
        {children}
        <Footer />
      </Body>
    </Page>
  )
}
